import {
    REQUEST_PASSWORD_EMAIL,
    REQUEST_PASSWORD_EMAIL_SUCCESS,
    REQUEST_PASSWORD_EMAIL_FAILED,
    RESET_PASSWORD_EMAIL,
    RESET_PASSWORD_EMAIL_SUCCESS,
    RESET_PASSWORD_EMAIL_FAILED
} from './actionTypes'

export const requestPasswordEmail = (data) => {
    return {
        type: REQUEST_PASSWORD_EMAIL,
        payload: data,
        meta:{
            thunk:true
        }
    }
}

export const requestPasswordEmailSuccess = (data, {thunk}) => {
    return {
        type: REQUEST_PASSWORD_EMAIL_SUCCESS,
        payload: data,
        meta: {
            thunk
        }
    }
}

export const requestPasswordEmailFailed = (error, {thunk}) => {
    return {
        type: REQUEST_PASSWORD_EMAIL_FAILED,
        payload: error,
        error: true,
        meta: {
            thunk
        }
    }
}

export const resetPasswordEmail = (data) => {
    return {
        type: RESET_PASSWORD_EMAIL,
        payload: data,
        meta:{
            thunk:true
        }
    }
}

export const resetPasswordEmailSuccess = (data, {thunk}) => {
    return {
        type: RESET_PASSWORD_EMAIL_SUCCESS,
        payload: data,
        meta: {
            thunk
        }
    }
}

export const resetPasswordEmailFailed = (error, {thunk}) => {
    return {
        type: RESET_PASSWORD_EMAIL_FAILED,
        payload: error,
        error: true,
        meta: {
            thunk
        }
    }
}